import React from "react";

import FormulaBuilder from "../../FormulaBuilder";

import { array, object, string, bool, number } from "yup";

import api from "../../../providers/api";

import { WizardStep } from "../Wizard";
import ParametersField from "../../ParametersField";

const validateFormula = async (Formula, Parameters) => {
  try {
    const { Data } = await api.kpi.validateFormula({
      Parameters,
      Formula,
    });
    return Data;
  } catch {
    return false;
  }
};

export const formulaValidationSchema = object().shape({
  Parameters: array()
    .of(
      object().shape({
        ParameterName: string().required(" "),
        Description: string().required(" "),
      })
    )
    .required(" "),
  Formula: array()
    .of(string().required(" "))
    .required(" ")
    .when(["Parameters"], (parameters, schema) => {
      if (parameters?.length) {
        return schema.test("validate-formula", " ", async (value) => {
          return await validateFormula(value?.join(""), parameters);
        });
      }
    }),
});

function Formula({ isEditMode, isReadOnly }) {
  return (
    <WizardStep name="Parameters">
      <div className="details-container" style={{ overflowY: "auto" }}>
        <ParametersField isEditMode={isEditMode} isReadOnly={isReadOnly} />

        <hr />

        <FormulaBuilder isEditMode={isEditMode} isReadOnly={isReadOnly} />
      </div>
    </WizardStep>
  );
}

export default Formula;
